import {
  StrollFill18Icon,
  WheelchairFill18Icon,
} from "@vygruppen/spor-icon-react";
import { Text, tokens } from "shared/components/Spor";
import { FC } from "react";
import styled from "styled-components";
import { CountryCode, TrainIdentifier } from "@vygruppen/vy-train-map";
import {
  EventAction,
  EventReason,
  OriginSystem,
} from "shared/types/operationalInformation";
import { VisibilityRequest } from "shared/form/visibilitySchema";
import { AffectedStop, Distribution } from "shared/types/historyDetail";
import { Nullish } from "shared/utils/objectUtils";

const AssistanceWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: ${tokens.default.size.spacing["0.5"]};
`;

type AssistanceEventType =
  | "TRAIN_REDUCED_MOBILITY_PASSENGER"
  | "TRAIN_VISUALLY_IMPAIRED_PASSENGER"
  | "TRAIN_WHEELCHAIR_PASSENGER";

export type WheelchairPassengerEvent = {
  uuid: string;
  version: number;
  countryCode: CountryCode;
  createdAt: string;
  updatedAt: string;
  originSystem: OriginSystem;
  type: "TRAIN_WHEELCHAIR_PASSENGER";
  state: "OPEN" | "CLOSED";
  isVisible: boolean;
  visibility: VisibilityRequest;
  distributions: Array<Distribution>;
  trainIdentifier: TrainIdentifier;
  lineNumber: string;
  reason: Nullish<EventReason>;
  action: Nullish<EventAction>;
  affectedStops: Array<AffectedStop>;
};

export function isWheelchairPassengerEvent(
  event: any,
): event is WheelchairPassengerEvent {
  return event?.type === "TRAIN_WHEELCHAIR_PASSENGER";
}

export type AssistanceEvent = WheelchairPassengerEvent;

type AssistanceTypeProps = {
  eventType: AssistanceEventType;
};

export const AssistanceType: FC<AssistanceTypeProps> = ({ eventType }) => {
  switch (eventType) {
    case "TRAIN_REDUCED_MOBILITY_PASSENGER":
      return (
        <AssistanceWrapper>
          <StrollFill18Icon />
          <Text variant="sm">Redusert bevegelighet</Text>
        </AssistanceWrapper>
      );

    case "TRAIN_VISUALLY_IMPAIRED_PASSENGER":
      return (
        <AssistanceWrapper>
          <StrollFill18Icon />
          <Text variant="sm">Synsnedsettelse</Text>
        </AssistanceWrapper>
      );

    case "TRAIN_WHEELCHAIR_PASSENGER":
      return (
        <AssistanceWrapper>
          <WheelchairFill18Icon />
          <Text variant="sm">Rullestol</Text>
        </AssistanceWrapper>
      );
  }
};
